import { SnapButton } from "suit";

const scrollToTop = () =>
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

type NavButtonsProps = {
  onNextClick?: () => void;
  onBackClick?: () => void;
  onSubmitClick?: () => void;
  nextButtonDisabled?: boolean;
  submitButtonDisabled?: boolean;
};

export default function NavButtons({
  onNextClick,
  onBackClick,
  onSubmitClick,
  nextButtonDisabled,
  submitButtonDisabled,
}: NavButtonsProps) {
  return (
    <div className="flex mt-2 justify-end gap-2">
      {onBackClick && (
        <SnapButton
          variant="tertiary"
          size="md"
          onClick={() => {
            onBackClick();
            scrollToTop();
          }}
          fullWidth
          className="mb-4"
        >
          Back
        </SnapButton>
      )}
      {onNextClick && (
        <SnapButton
          variant="secondary"
          size="md"
          onClick={() => {
            onNextClick();
            scrollToTop();
          }}
          fullWidth
          className="mb-4"
          disabled={nextButtonDisabled}
        >
          Next
        </SnapButton>
      )}
      {onSubmitClick && (
        <SnapButton
          variant="primary"
          size="md"
          onClick={() => {
            onSubmitClick();
            scrollToTop();
          }}
          fullWidth
          className="mb-4"
          disabled={submitButtonDisabled}
        >
          Submit
        </SnapButton>
      )}
    </div>
  );
}
